import { render, staticRenderFns } from "./TeacherCourseDuration.vue?vue&type=template&id=954685c2&scoped=true&"
import script from "./TeacherCourseDuration.vue?vue&type=script&lang=js&"
export * from "./TeacherCourseDuration.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCourseDuration.vue?vue&type=style&index=0&id=954685c2&prod&scoped=true&lang=less&"
import style1 from "./TeacherCourseDuration.vue?vue&type=style&index=1&id=954685c2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954685c2",
  null
  
)

export default component.exports